<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w7mZBJ/tc-custom/series-spread.jpg?1688985069329?1726197459507" alt="This image is the cover for the book The Shattered Lens, Alcatraz Versus the Evil Librarians"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Shattered Lens, Alcatraz Versus the Evil Librarians
      </h1>
      <p class="bookDescription body article font2">
        <b>The sci/fi fantasy adventures of Brandon Sanderson--#1 <i>New York Times</i> bestselling author of <i>The Knights of Crystallia</i> and the Mistborn series—have been praised as “genuinely funny” and “an excellent choice” and…and…</b><br/><br/>…and you know what? That’s enough. For too long, I’ve been telling you all how fantastic this Brandon Sanderson character is, and I’m just sick of it. Take it from me—I’ve actually met the guy.<br/><br/>Now me? I can be impressive. Unfortunately, that’s usually when the trouble starts. But not this time! Honest!<br/><br/>I mean, it’s hardly my fault that the kingdom of Mokia was about to fall to the evil forces of the Librarians.<br/><br/>And it’s not really my fault if I sort of accidentally led a small force of freedom fighters to the Mokian capital of Tuki Tuki to help save the city and its brave people.<br/><br/>And it’s definitely not my fault that the Librarians found out I was there and launched an all-out attack with giant robots and scary weapons that permanently knocked people out and blew huge holes in the ground and kidnapped people and then my Librarian mother showed up and ruined everything as usual while my father was too busy to care even though he’s the one who was going to unleash chaos on the world and my talent for breaking things was getting way out of control and I didn’t know what to do!!!<br/><br/>(<i>WHEW!</i>)<br/><br/>So…if you want to keep reading and find out what else was totally not—I repeat, NOT—my fault, go right ahead.<br/><br/>Just don’t blame me if you can’t stop turning the pages.<br/><br/><b>Praise for the Alcatraz series:</b><br/><br/>“Like Lemony Snicket and superhero comics rolled into one (and then revved up on steroids).”—<i>Publishers Weekly</i> (Starred Review)<br/>“An excellent choice to read aloud to the whole family.” —<i>NPR</i><br/>“Those who enjoy their fantasy with a healthy dose of slapstick humor will be delighted.” —<i>School Library Journal</i><br/>“Genuinely funny...plenty here to enjoy.” —<i>Locus</i><br/>“In this original, hysterical homage to fantasy literature, Sanderson’s first novel for youth  recalls the best in Artemis Fowl and A Series of Unfortunate Events.” —<i>VOYA</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brandon Sanderson, Hayley Lazo
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f34d4fba